import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const DotMenuVerticalIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M9.16632 8.00033C9.16614 8.6444 8.64438 9.16617 8.00031 9.16634C7.35608 9.16634 6.83349 8.64451 6.83331 8.00033C6.83331 7.356 7.35597 6.83334 8.00031 6.83334C8.64449 6.83351 9.16632 7.3561 9.16632 8.00033Z"
      fill="currentColor"
    />
    <path
      d="M9.16632 3.33366C9.16614 3.97773 8.64438 4.4995 8.00031 4.49967C7.35608 4.49967 6.83349 3.97784 6.83331 3.33366C6.83331 2.68932 7.35597 2.16666 8.00031 2.16666C8.64449 2.16684 9.16632 2.68943 9.16632 3.33366Z"
      fill="currentColor"
    />
    <path
      d="M9.16632 12.667C9.16614 13.3111 8.64438 13.8328 8.00031 13.833C7.35608 13.833 6.83349 13.3112 6.83331 12.667C6.83331 12.0227 7.35597 11.5 8.00031 11.5C8.64449 11.5002 9.16632 12.0228 9.16632 12.667Z"
      fill="currentColor"
    />
  </svg>
);
